import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-next3',
  templateUrl: './button-next3.component.html',
  styleUrls: ['./button-next3.component.less']
})
export class ButtonNext3Component implements OnInit {
  @Output() clicked = new EventEmitter();
  @Input() disabled: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }
  btn_click( ) {
    this.clicked.emit();
  }
}
